/* This file was automatically generated - please modify the template not this file! */

/* eslint-disable no-multiple-empty-lines */
import * as React from "react";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { Form, Button } from "semantic-ui-react";
import { FormBaseComponent, SaveDispatchProps } from "@neworbit/simpleui-forms";
import { Input } from "@neworbit/simpleui-input";
import isUrl = require("is-url");

import { createValidator } from "not-valid";

import { isYesNoOptionEnabledOptions } from "@teamprevent/common/model";
import { acceptableExtensions } from "@teamprevent/common/acceptableExtensions";
import { FileUpload } from "@teamprevent/common/fileUploads";
import { toast } from "@teamprevent/common/toasts";

import { CustomerDocumentCreateModel, AppState } from "../model";
import { basePathSelector } from "../selectors";
import { createCustomerDocument } from "../actions";
import { CustomerDocumentDetailModel } from "../model";
import { SelectorState, customerDocumentsSelector } from "../selectors";

import { Customer, CustomerState, selectors } from "../../customer";

import { CreateModal } from "./CreateModal";

import { push } from "redux-little-router";


export interface CreateProps {
    open: boolean;
    customer: Customer;
    customerDocuments: CustomerDocumentDetailModel[];
}

export interface DispatchProps extends SaveDispatchProps<CustomerDocumentCreateModel> {
    close: () => void;
}

export class Create extends FormBaseComponent<CustomerDocumentCreateModel, CreateProps> {

    constructor(props: CreateProps & SaveDispatchProps<CustomerDocumentCreateModel>) {
        super(props);
        this.state = {
            values: {
                id: "0",
                name: "",
                description: undefined,
                url: undefined,
                viewableByManager: false,
                blobId: undefined,
                fileName: undefined
            },
            valid: {}
        };

        this.notDuplicate = this.notDuplicate.bind(this);
    }

    private notDuplicate = createValidator<string>(
        value => !this.props.customerDocuments || !Array.isArray(this.props.customerDocuments) || !this.props.customerDocuments.some((wg) => wg.name === value),
        "Customer Document with this name already exists"
    );

    public UNSAFE_componentWillReceiveProps(props: CreateProps & SaveDispatchProps<CustomerDocumentCreateModel>) {
        this.setState(current => ({ values: { ...current.values, customerId: props.customer.id } }));
    }

    public render() {
        return (
            <Form onSubmit={this.handleSubmit}>

                <Input.Text
                    value={this.state.values.name}
                    label="Name"
                    showErrors={this.state.showErrors}
                    required
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange={(value, valid) => this.updateProperty("name", value, valid)}
                    validation={[this.notDuplicate]}
                />
                <Input.Text
                    value={this.state.values.description}
                    label="Description"
                    showErrors={this.state.showErrors}
                    required
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange={(value, valid) => this.updateProperty("description", value, valid)}
                />
                <Input.Text
                    value={this.state.values.url}
                    label="Url"
                    showErrors={this.state.showErrors}
                    validation={[urlValidator]}
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange={(value, valid) => this.updateProperty("url", value, valid)}
                />
                <br />
                <label>Upload document</label>
                <br />
                {this.state.values.fileName && this.state.values.blobId
                    ? <>
                        <a
                            // eslint-disable-next-line max-len
                            href={`/api/customer/${this.props.customer.id}/customerDocument/document/${this.state.values.blobId}?fileName=${this.state.values.fileName}`}
                        >
                            <Button content={this.state.values.fileName} type="button" />
                        </a>
                        <Button
                            className="remove-evidence-button"
                            content="Remove"
                            type="button"
                            onClick={() => this.removeDocument()}
                            floated="right"
                        />
                    </>
                    : <FileUpload
                        apiUrl={`/api/customer/${this.props.customer.id}/customerDocument/uploadDocument`}
                        onFileChange={(blobId: string, fileName: string) => this.onFileChange(blobId, fileName, this)}
                        fileName={this.state.values.fileName}
                        acceptExtensions={acceptableExtensions}
                    />
                }
                <br />
                <Input.Dropdown
                    value={this.state.values.viewableByManager.toString()}
                    label="Viewable by Manager"
                    options={isYesNoOptionEnabledOptions.map(c => ({ text: c.text, value: c.value }))}
                    showErrors={this.state.showErrors}
                    onChange={(value, valid) => this.updateProperty("viewableByManager", value === "true", valid)}
                />
                <Form.Field>
                    <label>Customer</label>
                    <span>{this.props.customer.name}</span>
                </Form.Field>
            </Form>
        );
    }

    public removeDocument(): void {
        this.setState({ values: { ...this.state.values, blobId: null, fileName: null } });
        this.updateProperty("blobId", null, true);
        this.updateProperty("fileName", null, true);
    }

    public onFileChange(blobId: string, fileName: string, that: any): void {
        that.setState({ values: { ...this.state.values, blobId, fileName } });
        that.updateProperty("blobId", blobId, true);
        that.updateProperty("fileName", fileName, true);
    }

    public submit(): void {
        if (!this.state.values.blobId &&
            !this.state.values.fileName &&
            !this.state.values.url) {

            toast.warning("Either URL or file should be provided.");
            return;
        }

        this.handleSubmit({ preventDefault: (): void => undefined } as any);
    }
}

const urlValidator = createValidator((value: string) => !value || isUrl(value), "Must be a valid URL");

function mapStateToProps(state: AppState & CustomerState & SelectorState) {
    return {
        customer: selectors.customerSelector(state),
        open: state.router.pathname.endsWith("/create"),
        basePath: basePathSelector(state),
        customerDocuments: customerDocumentsSelector(state),
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch<AppState, undefined, any>) {
    return {
        dispatchSave: (customerId: string, customerDocument: CustomerDocumentCreateModel, basePath: string) =>
            dispatch(createCustomerDocument(customerId, customerDocument, basePath)),
        dispatchClose: (basePath: string) => dispatch(push(basePath))
    };
}

function mergeProps(propsFromState: any, propsFromDispatch: any): CreateProps & DispatchProps {
    return {
        customer: propsFromState.customer,
        open: propsFromState.open,
        save: (customerDocument: CustomerDocumentCreateModel) =>
            propsFromDispatch.dispatchSave(propsFromState.customer.id, customerDocument, propsFromState.basePath),
        close: () => propsFromDispatch.dispatchClose(propsFromState.basePath),
        customerDocuments: propsFromState.customerDocuments,
    };
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CreateModal);
